import { services } from "../Constants/types";
import moment from "moment";

export const serviceMap = services.reduce((acc, service) => {
  acc[service.value] = service.label;
  return acc;
}, {});

export const getServiceLabel = (serviceValue, note) => {
  return serviceValue !== 0 ? serviceMap[serviceValue] || "" : note;
};

export const calculateFlightDuration = (start, end) => {
  if (!start || !end) return "";
  const startTime = moment(start);
  const endTime = moment(end);
  const duration = moment.duration(endTime.diff(startTime));

  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();

  return `${hours}h ${minutes.toString().padStart(2, "0")}m`;
};

export const generateCombinations = (destinations) => {
  const hotelLists = destinations.map((destination) =>
    destination.hotelsVo.map((hotel) => ({
      hotelListId: hotel.hotelListId,
      name: hotel.name,
    }))
  );

  const cartesianProduct = (arrays) =>
    arrays.reduce(
      (acc, array) =>
        acc.flatMap((item) => array.map((element) => [...item, element])),
      [[]]
    );

  return cartesianProduct(hotelLists);
};

export const groupedPrices = (prices) => {
  return prices.reduce((acc, price) => {
    if (!acc[price.name]) {
      acc[price.name] = [];
    }
    acc[price.name].push(price);
    return acc;
  }, {});
};
